import { getCVAppData } from "../../global/utility/Utils";
import { CCD_VERSION } from "../constants/devices";
export const getAllDeviceLocationList = (deviceList = [], location = "") => {
  if (!deviceList || deviceList?.length <= 0) return [];
  let deviceListObject = {};
  deviceList
    .filter((device) => device?.customdata?.location)
    .forEach((device) => {
      deviceListObject = {
        ...deviceListObject,
        [device.customdata.location]: device.customdata.location,
      };
    });
  if (location) {
    return ["All", ...new Set([...Object.keys(deviceListObject), location])];
  }
  return ["All", ...new Set([...Object.keys(deviceListObject)])];
};

export const getSensorsByLocation = (
  selectedLocation = "",
  deviceList = [],
  device = ""
) => {
  if (!selectedLocation || !selectedLocation.trim()) return [];
  const selectedSensors = deviceList
    .filter(
      (device) =>
        device.parentdeviceid &&
        (device?.customdata?.location === selectedLocation ||
          selectedLocation === "All")
    )
    .map((device) => device.name);
  if (device) {
    return [...new Set([...selectedSensors, device])];
  }
  return [...new Set([...selectedSensors])];
};

export const getCVAppByDevice = async (
  selectedDevice = "",
  deviceList = [],
  selectedField = "",
  activeSession,
  allCVApps
) => {
  try {
    if (!selectedDevice || !selectedDevice.trim()) return [];
    const telemetryFields = deviceList.filter(
      (device) => device && device.name === selectedDevice
    )[0];
    if (telemetryFields && telemetryFields.hasOwnProperty("fields")) {
      const fetchCameraCVAppsRsp = await getCVAppData(telemetryFields.id, activeSession);
      if (fetchCameraCVAppsRsp.error) {
      }
      let filterList = fetchCameraCVAppsRsp?.filter(
        (item) => item.status === "deployed" || item.status === "deploying"
      );
      for (let i = 0; i < filterList.length; i++) {
        let cvAppDetails = {};
        let cvApp = allCVApps?.find(item => item.id === filterList[i].appid);
        cvAppDetails.appName = cvApp?.name;
        filterList[i] = { ...filterList[i], ...cvAppDetails };
      }
      return filterList
    }
    return [];
  } catch (e) {
    console.log(e);
    return [];
  }
};


export const getTelemetryFieldsByDevice = (
  selectedDevice = "",
  deviceList = [],
  selectedField = ""
) => {
  if (!selectedDevice || !selectedDevice.trim()) return [];
  const telemetryFields = deviceList.filter(
    (device) => device && device.name === selectedDevice
  )[0];
  if (telemetryFields && telemetryFields.hasOwnProperty("fields")) {
    return selectedField
      ? [...new Set([...Object.keys(telemetryFields.fields), selectedField])]
      : [...new Set([...Object.keys(telemetryFields.fields)])];
  }
  return [];
};

export const getLocationByDeviceName = (deviceName = "", deviceList = []) => {
  const deviceLocation = deviceList.filter(
    (device) => device.name === deviceName
  )[0];
  if (deviceLocation && deviceLocation.hasOwnProperty("customdata")) {
    return deviceLocation.customdata.location;
  }
};

export function getDeviceType(sensorData) {
  let deviceList = JSON.parse(sessionStorage.getItem("deviceList"));
  let parentDevice = sensorData?.data?.parentdeviceid
    ? sensorData.data.parentdeviceid
    : null;

  let gateway;
  if (
    typeof parentDevice !== "undefined" &&
    typeof deviceList !== "undefined"
  ) {
    for (let i = 0; i < deviceList?.length; i++) {
      if (deviceList[i].id === parentDevice) {
        gateway = deviceList[i];
      }
    }
  }
  let ble = false;
  let lora = false;
  let IOKey = false;
  if (typeof gateway !== "undefined") {
    //check to see if ble gateway
    console.log(gateway);
    ble = gateway.kind === "ts.device.tgAssetTracker" ? true : false;
    lora =
      gateway.kind === "ts.device.gateway.lorawan.multitech" ? true : false;
    IOKey = gateway.kind === "ts.device.gateway.iokey.ifm" ? true : false;
  }
  return { ble, lora, IOKey };
}

export const getCompanionObjectbyId = (parentId, itemList) => {
  const filteredItems = itemList.filter((item) => item.id === parentId);
  return filteredItems;
};

// Helper function to safely decode URI components
export const safeDecodeURIComponent = (str) => {
  try {
    const decoded = decodeURIComponent(str);
    // Only return decoded if it's different from original (was actually encoded)
    return decoded !== str ? decoded : str;
  } catch (e) {
    // Return original string if decoding fails (malformed URI)
    return str;
  }
};


export const isCcdHasInHouseVersion = (ccdInfo) => {
  const ccdVersion = ccdInfo?.fields?.ccdversion ?? "1";
  const majorVersion = ccdVersion.includes(".") ? ccdVersion.split(".")[0] : ccdVersion;
  const versionParsed = parseInt(majorVersion, 10) || 1;
  return versionParsed >= parseInt(CCD_VERSION.IN_HOUSE_VERSION, 10);
};

export const isCompanionV2 = (companionDeviceList, companionId) => {
  const companion = companionDeviceList?.find((c) => c?.id === companionId);
  return isCcdHasInHouseVersion(companion);
};

